import React, { useState, useContext } from "react";
import ReactCountryFlag from "react-country-flag";
import NewPublicationBarProfile from "../../components/layout/NewPublicationBarProfile";
import { ModalPost } from "../../components/modals/ModalPost";
import { UserDataContext } from "../../contexts/Contexts";
import { useMediaQuery } from "react-responsive";
import DropdownButton from "./utils/DropdownButton";

const UserHeaderProfile = () => {
  const { userData } = useContext(UserDataContext);

  const isMobile = useMediaQuery({ maxWidth: 630 });

  const [open, setOpen] = useState(false);

  return (
    <div>
      {!isMobile ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            background:
              "linear-gradient(to bottom, #fdede9, #fbded7, #fbdcd3, #ffff)",
          }}
        >
          <div
            style={{
              width: "85%",
              // border: "1px solid red",
              backgroundImage: "url('/img/bg-images/desktop/profile-bg.png')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              zIndex: "1",
              padding: "2rem",
              borderRadius: "0 0 48px 48px",
            }}
          >
            <div>
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  alignItems: "center",
                  justifyContent: "space-between",
                  // border: "1px solid"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "1rem",
                    alignItems: "center",
                  }}
                >
                  <div
                    className={"user-header-profile-container center-elements"}
                  >
                    <img
                      src={userData?.profilePic}
                      alt={"profile-pic"}
                      className={"profile-img-sidebar"}
                    />
                  </div>
                  <div style={{ color: "white" }}>
                    <p
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                        padding: "0",
                        margin: "0",
                      }}
                    >
                      {userData?.nombres + " " + userData?.apellidos}
                      <ReactCountryFlag
                        className={"center-elements"}
                        style={{ marginLeft: "5px" }}
                        countryCode={userData?.idNacionalidad}
                        svg
                      />
                    </p>
                    <p style={{ fontSize: "14px", padding: "0", margin: "0" }}>
                      {userData?.nickName}
                    </p>
                    <p style={{ fontSize: "14px", padding: "0", margin: "0" }}>
                      {userData?.localizacion}
                    </p>
                  </div>
                </div>
                <div style={{ width: "70%" }}>
                  <NewPublicationBarProfile
                    open={open}
                    setOpen={setOpen}
                    ModalComponent={ModalPost}
                  />
                </div>
                <div>
                  <DropdownButton />
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            background:
              "linear-gradient(to bottom, #fdede9, #fbded7, #fbdcd3, #ffff)",
          }}
        >
          <div
            style={{
              width: "100%",
              // border: "1px solid red",
              backgroundImage: "url('/img/bg-images/desktop/profile-bg.png')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              zIndex: "1",

              borderRadius: "0 0 48px 48px",
            }}
          >
            <div>
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  flexDirection: "column",
                  // border: "1px solid"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "1rem",
                    alignItems: "center",
                    flexDirection: "column",
                    marginTop: "1rem",
                  }}
                >
                  <div
                    className={"user-header-profile-container center-elements"}
                  >
                    <img
                      src={userData?.profilePic}
                      alt={"profile-pic"}
                      className={"profile-img-sidebar"}
                    />
                  </div>
                  <div style={{ color: "white" }}>
                    <div style={{ padding: "0 2rem" }}>
                      <p
                        style={{
                          fontSize: "20px",
                          fontWeight: "bold",
                          padding: "0",
                          margin: "0",
                        }}
                      >
                        {userData?.nombres + " " + userData?.apellidos}
                        <ReactCountryFlag
                          className={"center-elements"}
                          style={{ marginLeft: "5px" }}
                          countryCode={userData?.idNacionalidad}
                          svg
                        />
                      </p>
                      <p
                        style={{ fontSize: "14px", padding: "0", margin: "0" }}
                      >
                        {userData?.nickName}
                      </p>
                      <p
                        style={{ fontSize: "14px", padding: "0", margin: "0" }}
                      >
                        {userData?.localizacion}
                      </p>
                    </div>
                    <div></div>

                    <div style={{ padding: "1rem" }}>
                      <NewPublicationBarProfile
                        open={open}
                        setOpen={setOpen}
                        ModalComponent={ModalPost}
                      />
                    </div>
                  </div>
                </div>
                {/* <div style={{ width: "100%" }}>
                  <NewPublicationBarProfile
                    open={open}
                    setOpen={setOpen}
                    ModalComponent={ModalPost}
                  />
                </div> */}
              </div>
              <div>
                <DropdownButton />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserHeaderProfile;
